"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ConversationalSearchModal;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _conversationalSearch = require("@site/conversational-search");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _icon = require("@site/pattern-library-utils/icon");
var _core = require("@linaria/core");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-console */

"pl-cr7eirb";
function ConversationalSearchModal({
  buttonAriaLabel,
  searchBoxPlaceholderText,
  apiKey,
  plid,
  eid,
  buttonDesign,
  buttonSize,
  buttonText,
  modalWidth,
  itc,
  continueToCartSkipConfig,
  disableContinueToCart,
  tccApiKeys,
  enableFavorites,
  appName = 'FOS',
  ...conversationalSearchProps
}) {
  const [isConversationalSearchModalVisible, setIsConversationalSearchModalVisible] = (0, _react.useState)(false);
  const handleOpenModalClick = () => {
    setIsConversationalSearchModalVisible(true);
    (0, _patternLibraryUtils.logEvent)({
      eid: `${eid}.click`,
      type: 'click'
    });
  };
  (0, _react.useEffect)(() => {
    isConversationalSearchModalVisible && (0, _patternLibraryUtils.logImpression)(`${eid}.impression`);
  }, [isConversationalSearchModalVisible, eid]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButton, {
    text: buttonText,
    size: buttonSize,
    design: buttonDesign,
    "data-cy": "conversational-search-open-modal-button",
    onClick: handleOpenModalClick,
    "aria-label": buttonAriaLabel,
    className: 'font-weight-bold w-100 border-radius-8',
    icon: /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      name: "wand",
      width: 24,
      height: 24
    })
  }), isConversationalSearchModalVisible && /*#__PURE__*/_react.default.createElement(_conversationalSearch.ConversationalSearch, (0, _extends2.default)({
    searchBoxPlaceholder: searchBoxPlaceholderText,
    apiKey: apiKey,
    plid: plid,
    modalStyling: {
      width: modalWidth
    },
    options: {
      continueToCartSkipConfig,
      disableContinueToCart,
      itc,
      enableFavorites
    },
    enableDynamicFontScaling: true,
    tccApiKeys: tccApiKeys,
    onModalClose: () => setIsConversationalSearchModalVisible(false),
    appName: appName
  }, conversationalSearchProps)));
}
ConversationalSearchModal.displayName = 'ConversationalSearchModal';
ConversationalSearchModal.propTypes = {
  buttonAriaLabel: _propTypes.default.string,
  searchBoxPlaceholderText: _propTypes.default.string,
  apiKey: _propTypes.default.string,
  plid: _propTypes.default.number,
  eid: _propTypes.default.string,
  buttonDesign: _propTypes.default.string,
  buttonSize: _propTypes.default.string,
  buttonText: _propTypes.default.string,
  modalWidth: _propTypes.default.string,
  itc: _propTypes.default.string,
  continueToCartSkipConfig: _propTypes.default.bool,
  disableContinueToCart: _propTypes.default.bool,
  tccApiKeys: _propTypes.default.object,
  enableFavorites: _propTypes.default.bool,
  ..._conversationalSearch.ConversationalSearch.propTypes
};